export default __webpack_public_path__ + "static/media/black_logout.ef23b47c.svg";